export default __webpack_public_path__ + "static/img_desktop_3-2e24e3372eb83dada533228f291b1292.jpg";